module.exports = __webpack_public_path__ + "bdfb7955d15cdf94c97f901b16e99623.png";